import React, { useRef } from 'react';
import { Drawer, DrawerRef } from '@/components/shared/panel/Drawer';
import { ActionButton } from '@/components/shared/button/ActionButton';
import { StatusHistory } from '@/components/testIssue/StatusHistory';

type StatusHistoryModalProps = {
  testIssueId: string;
};
const StatusHistoryModal: React.FC<StatusHistoryModalProps> = ({ testIssueId }) => {
  const ref = useRef<DrawerRef>(null);
  return (
    <>
      <button
        className="flex items-center gap-2 p-2 bg-gray-200 border rounded-md"
        onClick={() => ref.current?.open()}
      >
        <ActionButton.History /> History
      </button>

      <Drawer ref={ref}>
        <StatusHistory id={testIssueId} />
      </Drawer>
    </>
  );
};

export default StatusHistoryModal;
